import { useContext } from "react"
import { ImagePreviewModalContext } from "./GenericImagePreviewModal"

export const useImagePreviewModalContext = () => {
    const context = useContext(ImagePreviewModalContext)
    return context
}
